import React from "react";
import "./loader.css";

const Loader = () => {
  return (
    <div className="loader-main">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
